"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRefetch = require("react-refetch");

var _Icon = _interopRequireDefault(require("./Icon.js"));

var _lodash = require("lodash");

var _urijs = _interopRequireDefault(require("urijs"));

var _expressionAtlasDisclaimers = _interopRequireDefault(require("@ebi-gene-expression-group/expression-atlas-disclaimers"));

var _lib = require("react-bootstrap/lib");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ResourcesSection = function ResourcesSection(_ref) {
  var values = _ref.values,
      pathToResources = _ref.pathToResources,
      atlasUrl = _ref.atlasUrl;
  var subsections = (0, _lodash.uniq)(values.map(function (value) {
    return value.group;
  }));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "row column expanded margin-top-large"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    style: {
      listStyle: "none"
    }
  }, subsections.filter(function (el) {
    return el;
  }).length < 2 ? values.map(function (value, ix, self) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: ix
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: (0, _urijs["default"])(value.url, atlasUrl)
    }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      type: value.type,
      pathToResources: pathToResources
    }), value.description)));
  }) : subsections.map(function (subsectionName, ix) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: ix
    }, /*#__PURE__*/_react["default"].createElement("ul", {
      style: {
        listStyle: "none"
      },
      className: "margin-left-none margin-bottom-medium"
    }, /*#__PURE__*/_react["default"].createElement("i", null, subsectionName), values.filter(function (value) {
      return subsectionName === value.group;
    }).map(function (value, jx, self) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: jx,
        className: "margin-left-large"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: (0, _urijs["default"])(value.url, atlasUrl)
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        type: value.type,
        pathToResources: pathToResources
      }), " ", value.description))));
    })));
  })));
};

var DisclaimerWrapper = /*#__PURE__*/function (_Component) {
  _inherits(DisclaimerWrapper, _Component);

  var _super = _createSuper(DisclaimerWrapper);

  function DisclaimerWrapper(props) {
    var _this;

    _classCallCheck(this, DisclaimerWrapper);

    _this = _super.call(this, props);
    _this.state = {
      needsAck: Boolean(_this.props.disclaimer && _expressionAtlasDisclaimers["default"][_this.props.disclaimer])
    };
    return _this;
  }

  _createClass(DisclaimerWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var Disclaimer = _expressionAtlasDisclaimers["default"][this.props.disclaimer];
      return /*#__PURE__*/_react["default"].createElement("div", null, this.state.needsAck ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Disclaimer, null), /*#__PURE__*/_react["default"].createElement(_lib.Button, {
        onClick: function onClick() {
          return _this2.setState({
            needsAck: false
          });
        }
      }, "Continue to download")) : this.props.children);
    }
  }]);

  return DisclaimerWrapper;
}(_react.Component);

DisclaimerWrapper.propTypes = {
  disclaimer: _propTypes["default"].string,
  children: _propTypes["default"].element.isRequired
};

var ResourcesTab = /*#__PURE__*/function (_Component2) {
  _inherits(ResourcesTab, _Component2);

  var _super2 = _createSuper(ResourcesTab);

  function ResourcesTab() {
    _classCallCheck(this, ResourcesTab);

    return _super2.apply(this, arguments);
  }

  _createClass(ResourcesTab, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          resourcesFetch = _this$props.resourcesFetch,
          atlasUrl = _this$props.atlasUrl,
          pathToResources = _this$props.pathToResources,
          disclaimer = _this$props.disclaimer;

      if (resourcesFetch.pending) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "row column expanded margin-top-large"
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: (0, _urijs["default"])("resources/images/loading.gif", atlasUrl)
        }));
      } else if (resourcesFetch.rejected) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "row column expanded margin-top-large"
        }, /*#__PURE__*/_react["default"].createElement("p", null, "Error: ", resourcesFetch.reason));
      } else if (resourcesFetch.fulfilled) {
        return /*#__PURE__*/_react["default"].createElement(DisclaimerWrapper, {
          disclaimer: disclaimer
        }, /*#__PURE__*/_react["default"].createElement(ResourcesSection, {
          values: resourcesFetch.value,
          pathToResources: pathToResources,
          atlasUrl: atlasUrl
        }));
      }
    }
  }]);

  return ResourcesTab;
}(_react.Component);

var _default = (0, _reactRefetch.connect)(function (props) {
  return {
    resourcesFetch: (0, _urijs["default"])(props.url, props.atlasUrl).toString()
  };
})(ResourcesTab);

exports["default"] = _default;